const defaultQueryParams = {
  status: null,
  fullName: '',
  email: null,
  sortBy: 'creationDate',
  page: 1,
  pageSize: 50,
  sortDirection: 'desc',
}

export default {
  data() {
    return {
      defaultQueryParams: { ...defaultQueryParams },
      queryParams: { ...defaultQueryParams },
    }
  },
  created() {
    this.getDataAction(this.preparedRouterQuery, false)
    this.getData(this.requestQuery)
  },
  computed: {
    filteredQueryKeys() {
      return Object.keys(this.queryParams).filter(
        key => this.queryParams[key] || this.defaultQueryParams[key],
      )
    },
    urlQueryParams() {
      return this.filteredQueryKeys.reduce((acc, key) => {
        const value = this.queryParams[key]
        if (value && value !== this.defaultQueryParams[key]) {
          acc[key] = value
        }

        return acc
      }, {})
    },
    preparedRouterQuery() {
      const keys = Object.keys(this.$route.query)

      return keys.length
        ? keys.reduce(
            (acc, key) => {
              if (key === 'programsId') {
                acc[key] = this.$route.query[key]
                return acc
              }

              const number = Number(this.$route.query[key], 10)
              const isDateValid = this.$moment(this.$route.query[key]).isValid()
              const isDate =
                isDateValid &&
                (this.$route.query[key].indexOf(':') > -1 ||
                  this.$route.query[key].indexOf('-') > -1)

              if (!isNaN(number) && !isDate) {
                acc[key] = number
              } else {
                acc[key] = this.$route.query[key]
              }

              return acc
            },
            { ...this.defaultQueryParams },
          )
        : { ...this.defaultQueryParams }
    },
    requestQuery() {
      return this.filteredQueryKeys.reduce((acc, key) => {
        // API counts pages from 0
        acc.append(
          key,
          key === 'page' ? this.queryParams[key] - 1 : this.queryParams[key],
        )
        return acc
      }, new URLSearchParams())
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.getDataAction(this.preparedRouterQuery, false)
        this.getData(this.requestQuery)
      },
      deep: true,
    },
  },
  methods: {
    getDataAction(data, pushToRouter = true, forceLoad = false) {
      if (Object.keys(data).some(key => data[key] !== this.queryParams[key])) {
        this.queryParams = { ...this.queryParams, ...data }

        pushToRouter && this.$router.push({ query: this.urlQueryParams })
        !pushToRouter && this.getData(this.requestQuery)
      } else if (forceLoad) {
        this.queryParams = this.removeNulls(data)
        this.getData(this.requestQuery)
      }
    },
    getData() {
      console.log('you should redefine getData method')
    },
    removeNulls(data) {
      return Object.entries(data).reduce(
        (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
        {},
      )
    },
  },
}
